<div align="right">
  <button  mat-raised-button color="accent" (click)="logout()">
    <mat-icon>logout</mat-icon>
    </button>
</div>

<html>
  <h1> Encuestas disponibles para Estudiantes</h1>

 <div  *ngFor="let encuesta of listaencuesta let i = index" >
  <li>
    <a  aria-current="page" href="/encuestas/{{encuesta.encuesta_id}}" >{{encuesta.nombre}}</a>
  </li>
 </div>
</html>
